<template>
  <div class="child_wrap">
    <Form :ref="'form' + current" :model="form" :rules="rules" :label-width="175">
      <template v-for="(item, index) in form.childrenList">
        <div class="childBox_childPage" :key="index">
          <Row :gutter="16">
            <Col span="12">
            <FormItem :label="'子女' + (index + 1) + '姓名'">
              <Input v-model.trim="form.childrenList[index].name" disabled :maxlength="40" placeholder="">
              </Input>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem :label="'子女' + (index + 1) + '身份证号'">
              <Input v-model.trim="form.childrenList[index].idCardNo" disabled :maxlength="40" @on-blur="getChildAge('form' + current,index)" placeholder="请输入">
              </Input>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem :label="'子女' + (index + 1) + '年龄'">
              <Input type="number" readonly disabled v-model.trim.number="form.childrenList[index].age" placeholder="">
              </Input>
            </FormItem>
            </Col>
            <!-- 选择配偶 -->
            <Col span="24">
            <Row>
              <Col span="24">
              <FormItem :label="'子女' + (index + 1) + '情况'">
                <RadioGroup v-model.trim="form.childrenList[index].childType">
                  <Radio :label="value" disabled v-for="{ text, value } in $store.state.materiaBasicData
                        .childType" :key="value">{{ text }}</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="24">
              <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))" v-show="form.childrenList[index].childType===$store.state.childTypeEnum['亲生']">
                <Select v-model.trim="form.childrenList[index].applicationSpouseId" disabled style="width:200px">
                  <Option value=""> 无 </Option>
                  <Option v-for="item in spouseList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="24" class="childBox_childPage" v-if="form.childrenList[index].childType===$store.state.childTypeEnum['亲生']&&form.childrenList[index].applicationSpouseId>0">
              <Row>
                <Col span="24">
                <FormItem :label="'申请人与子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'的婚姻状况'">
                  <RadioGroup v-model.trim="spouseInfoList[index].maritalStatus">
                    <Radio :label="value" v-for="{ text, value } in $store.state.materiaBasicData
                    .maritalStatus" disabled :key="value">{{ text }}</Radio>
                  </RadioGroup>
                </FormItem>
                </Col>
                <!-- 子女的生母的婚姻状况 已婚时 -->
                <template v-if="spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚']">
                  <Col span="12">
                  <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证人像面'">
                    <Row :gutter="16">
                      <Col span="24">
                      <div class="line_area">
                        <!-- 已上传图片 -->
                        <div class="fileList" v-if="spouseInfoList[index].idCardFrontGuid">
                          <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                          <span class="pos">
                            <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ spouseInfoList[index].idCardFrontGuid" />
                            <i class="img_magnify">
                              <Icon size="26" class="ico" color="#ffffff" @click="handleView(spouseInfoList[index].idCardFrontGuid)" type="ios-eye" />
                            </i>
                          </span>
                          <!-- </template> -->
                        </div>
                        <div class="fileList" v-else>
                          <span class="pos">
                            <span class="img">
                              <span class="uploadImageNo">
                                <Icon type="ios-image" size="30" />
                              </span>
                            </span>
                          </span>
                        </div>
                      </div>
                      </Col>
                    </Row>
                  </FormItem>
                  </Col>
                  <Col span="12">
                  <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证国徽面'" prop="idCardBackGuid">
                    <Row :gutter="16">
                      <Col span="24">
                      <div class="line_area">
                        <!-- 已上传图片 -->
                        <div class="fileList" v-if="spouseInfoList[index].idCardBackGuid">
                          <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                          <span class="pos">
                            <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ spouseInfoList[index].idCardBackGuid" />
                            <i class="img_magnify">
                              <Icon size="26" class="ico" color="#ffffff" @click="handleView(spouseInfoList[index].idCardBackGuid)" type="ios-eye" />
                            </i>
                          </span>
                          <!-- </template> -->
                        </div>
                        <div class="fileList" v-else>
                          <span class="pos">
                            <span class="img">
                              <span class="uploadImageNo">
                                <Icon type="ios-image" size="30" />
                              </span>
                            </span>
                          </span>
                        </div>
                      </div>
                      </Col>
                    </Row>
                  </FormItem>
                  </Col>
                </template>
                <Col span="12">
                <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'姓名'">
                  <Input v-model.trim="spouseInfoList[index].name" disabled placeholder="请输入">
                  </Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证'">
                  <Input v-model.trim="spouseInfoList[index].idCardNo" disabled placeholder="请输入">
                  </Input>
                </FormItem>
                </Col>
              </Row>
              <!-- 子女的生母的婚姻状况 已婚时 -->
              <Col span="12" v-show="spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚']">
              <FormItem label="持证人结婚证原件">
                <Row :gutter="16">
                  <Col span="24">
                  <div class="line_area">
                    <!-- 已上传图片 -->
                    <div class="fileList" v-if="spouseInfoList[index].marriageCertificateGuid">
                      <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                      <span class="pos">
                        <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ spouseInfoList[index].marriageCertificateGuid" />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" @click="handleView(spouseInfoList[index].marriageCertificateGuid)" type="ios-eye" />
                        </i>
                      </span>
                      <!-- </template> -->
                    </div>
                    <div class="fileList" v-else>
                      <span class="pos">
                        <span class="img">
                          <span class="uploadImageNo">
                            <Icon type="ios-image" size="30" />
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  </Col>
                </Row>
              </FormItem>
              </Col>
              <!-- 子女的生母的婚姻状况 离异时 -->
              <Row v-show="spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['离异']">
                <Col span="24">
                <FormItem :label="'离婚证'" prop="divorceCertificateGuid">
                  <Row :gutter="16">
                    <Col span="24">
                    <div class="line_area">
                      <!-- 已上传图片 -->
                      <div class="fileList" v-if="spouseInfoList[index].divorceCertificateGuid">
                        <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                        <span class="pos">
                          <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ spouseInfoList[index].divorceCertificateGuid" />
                          <i class="img_magnify">
                            <Icon size="26" class="ico" color="#ffffff" @click="handleView(spouseInfoList[index].divorceCertificateGuid)" type="ios-eye" />
                          </i>
                        </span>
                        <!-- </template> -->
                      </div>
                      <div class="fileList" v-else>
                        <span class="pos">
                          <span class="img">
                            <span class="uploadImageNo">
                              <Icon type="ios-image" size="30" />
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    </Col>
                  </Row>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem :label="'离婚协议'">
                  <div class="_link" v-for="file in spouseInfoList[index].divorceSettlementGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].divorceSettlementGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem :label="'法院判决材料'">
                  <div class="_link" v-for="file in spouseInfoList[index].courtJudgmentGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].courtJudgmentGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem :label="'法院调解书'" prop="courtMediationLetterGuid">
                  <div class="_link" v-for="file in spouseInfoList[index].courtMediationLetterGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].courtMediationLetterGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
              </Row>
              <!--子女的生母的婚姻状况 丧偶时  -->
              <Row v-show="spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶']">
                <Col span="24">
                <FormItem :label="'死亡证明'">
                  <div class="_link" v-for="file in spouseInfoList[index].deathCertificateGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].deathCertificateGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem :label="'户籍注销'">
                  <div class="_link" v-for="file in spouseInfoList[index].domicileCancelGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].domicileCancelGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                <FormItem :label="'其他材料'" prop="spouseOtherGuidList">
                  <div class="_link" v-for="file in spouseInfoList[index].spouseOtherGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].spouseOtherGuidListPreview.length<1">无</span>

                </FormItem>
                </Col>
              </Row>

              </Col>

            </Row>

            </Col>

            <!-- 领养 -->
            <Col span="24" v-show="form.childrenList[index].childType===$store.state.childTypeEnum['领养']">
            <FormItem :label="'子女' + (index + 1) + '的领养证明材料'">
              <!-- <Upload :show-upload-list="false" :default-file-list="form.childrenList[ index ].adoptionCertificateGuidListPreview" :on-preview="handlePreview" :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                  (file, fileList) =>
                    handleRemove(
                      file,
                      fileList,
                      `childrenList[${index}].adoptionCertificateGuidList`,true
                    )
                " :on-success="
                  (response, file, fileList) =>
                    handleSuccess(
                      response,
                      file,
                      fileList,
                      `childrenList[${index}].adoptionCertificateGuidList`,true
                    )
                " :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
              </Upload> -->
              <div class="_link" v-for="file in form.childrenList[ index ].adoptionCertificateGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                <Icon :type="file.name | fileType" />
                {{file.name}}
              </div>
              <span class='_noLink' v-if="form.childrenList[ index ].adoptionCertificateGuidListPreview.length<1">无</span>

            </FormItem>
            </Col>
            <Col span="24">
            <FormItem :label="'子女' + (index + 1) + '户籍'">
              <RadioGroup v-model.trim="form.childrenList[index].registeredResidenceType">
                <Radio :label="value" disabled v-for="{ text, value } in $store.state.materiaBasicData
                    .registeredResidenceType" :key="value">{{ text }}</Radio>
              </RadioGroup>
            </FormItem>
            </Col>
            <Col span="24" v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']">
            <FormItem :label="'子女' + (index + 1) + '集体户口类型'">
              <RadioGroup disabled v-model.trim="form.childrenList[index].collectiveAccountMaterialsType">
                <Radio :label="value" disabled v-for="{ text, value } in $store.state.materiaBasicData
                    .collectiveAccountMaterialsTypes" :key="value">{{ text }}</Radio>
              </RadioGroup>
            </FormItem>
            </Col>
            <Col span="12"
              v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
            <FormItem :label="'上传子女' + (index + 1) + '户口簿详细地址页的首页'">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">

                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="
                        form.childrenList[index].residenceBookletMainPageGuid
                      ">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .residenceBookletMainPageGuid
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].residenceBookletMainPageGuid)" type="ios-eye" />

                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="12"
              v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
            <FormItem :label="'上传子女' + (index + 1) + '户口簿本人信息页'">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">

                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="
                        form.childrenList[index].residenceBookletSelfPageGuid
                      ">
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .residenceBookletSelfPageGuid
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].residenceBookletSelfPageGuid)" type="ios-eye" />

                      </i>
                    </span>
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="12"
              v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
            <FormItem :label="'上传子女' + (index + 1) + '派出所出具的户籍证明'" :prop="'childrenList[' + index + '].policeStationRegistrationCertificateGuid'">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="
                        form.childrenList[index].policeStationRegistrationCertificateGuid 
                      ">
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .policeStationRegistrationCertificateGuid 
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].policeStationRegistrationCertificateGuid )" type="ios-eye" />

                      </i>
                    </span>
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="24">
            <FormItem :label="'上传子女' + (index + 1) + '出生医学证明原件'">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">

                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="form.childrenList[index].birthCertificateGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index].birthCertificateGuid
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].birthCertificateGuid)" type="ios-eye" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <!-- <template v-if="true"> -->
            <Col span="12" v-show="form.childrenList[index].age >= 16">
            <FormItem :label="'上传子女' + (index + 1) + '全日制普通高中就读证明'">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="form.childrenList[index].fullTimeHighSchoolGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index].fullTimeHighSchoolGuid
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].fullTimeHighSchoolGuid)" type="ios-eye" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="12" v-show="form.childrenList[index].age >= 16">
            <FormItem :label="'上传子女' + (index + 1) + '学籍证明原件'">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">

                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="form.childrenList[index].studentCertificateGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="$baseURL + '/file/cover/' +  form.childrenList[index].studentCertificateGuid" />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].studentCertificateGuid)" type="ios-eye" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="24">
            <FormItem :label="'子女' + (index + 1) + '的其他材料'">
              <!-- <Upload :show-upload-list="false" :default-file-list="form.childrenList[ index ].otherMaterialGuidListPreview" :on-preview="handlePreview" :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                  (file, fileList) =>
                    handleRemove(
                      file,
                      fileList,
                      `childrenList[${index}].otherMaterialGuidList`,true
                    )
                " :on-success="
                  (response, file, fileList) =>
                    handleSuccess(
                      response,
                      file,
                      fileList,
                      `childrenList[${index}].otherMaterialGuidList`,true
                    )
                " :on-format-error="handleFormatError">
                <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
              </Upload> -->
              <div class="_link" v-for="file in form.childrenList[ index ].otherMaterialGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                <Icon :type="file.name | fileType" />
                {{file.name}}
              </div>
              <span class='_noLink' v-if="form.childrenList[ index ].otherMaterialGuidListPreview.length<1">无</span>

            </FormItem>
            </Col>
          </Row>
        </div>
      </template>
    </Form>

  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  computed: {
    spouseInfoList() {
      let list = []
      let _this = this
      this.form.childrenList.map((el, index) => {
        //为领养时无生父母数据
        if (el.childType == this.$store.state.childTypeEnum['领养']) {
          list.push(null)
          return
        }
        //无生父母信息id时
        if (el.applicationSpouseId <= 0) {
          list.push(null)
          return
        }
        let SpouseIdIndex = _this.spouseList.findIndex((item) => item.id === el.applicationSpouseId)
        list.push(_this.spouseList[SpouseIdIndex])
      })
      return list
    },
  },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      formSpouse: {
        guid: '',
        name: '',
        idCardNo: '',
        phone: '',
        applicationId: null,
        idCardFrontGuid: '',
        idCardBackGuid: '',
        registeredResidenceType: null,
        residenceBookletMainPageGuid: '',
        residenceBookletSelfPageGuid: '',
        marriageCertificateGuid: '',
        divorceCertificateGuid: '',
        courtJudgmentGuid: '',
        courtMediationLetterGuid: '',
        maritalStatus: null,
        id: 0,
      },
      spouseList: [],
      spouseType: '添加',
      accept: 'image/*',
      modalShow: false,
      modalLoading: true,
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: {},
      jyList: [{ name: '教育类型1', value: '教育类型1' }],
      xxxsList: [{ name: '普通全日制', value: '普通全日制' }],
      xlList: [{ name: '学历1', value: '学历1' }],
      xwList: [{ name: '学位1', value: '学位1' }],
      current_index: this.current,
      appInfoDataType: this.$store.state.appInfoDataType,
      ywlbList: [
        {
          name: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
          value: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
        },
      ],
      rules: {},
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  mounted() {
    let _this = this
    // setTimeout(()=>{_this.getSpouseList()}, 100)
    _this.getSpouseList()
    // this.spouseList = this.form.spouseList
  },
  methods: {
    // 获取子女年龄
    async getChildAge(name, index) {
      this.$refs[name].validateField('childrenList[' + index + '].idCardNo', async (res) => {
        if (res) {
          return
        }
        this.$emit('getAgeByCardId', this.form.childrenList[index].idCardNo, index)
      })
    },
    //获取配偶列表
    async getSpouseList() {
      this.spouseList = []
      let guid = this.form.guid
      let form2 = JSON.stringify(this.form)
      if (!guid) {
        this.spouseList = this.form.spouseList
        return
      }
      let { data } = await this.$Ajax.get('/api/services/app/JZZJFApi/GetApplicationSpouseList', {
        params: { guid },
      })
      if (Array.isArray(data.result)) {
        this.spouseList = data.result
      }
    },
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (val < this.current) {
        // this.$emit('next', val)
        if (!this.form.isSpouseEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['申请人基本信息'])
          return
        }
        if (this.form.isSpouseEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'])
          return
        }
        return
      }
      //下一步
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        let submitUrl = '/api/services/app/JZZJFApi/SaveAppChildrenInfo'
        if (!this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['加分材料'], submitUrl)
          return
        }
        if (this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['学历信息'], submitUrl)
          return
        }
      })
    },
    addSpouse(name, type, id) {
      this.modalLoading = false
      this.modalShow = true
      this.spouseType = type
      this.formSpouse = {
        guid: '',
        name: '',
        idCardNo: '',
        phone: '',
        applicationId: null,
        idCardFrontGuid: '',
        idCardBackGuid: '',
        registeredResidenceType: null,
        residenceBookletMainPageGuid: '',
        residenceBookletSelfPageGuid: '',
        marriageCertificateGuid: '',
        divorceCertificateGuid: '',
        courtJudgmentGuid: '',
        courtMediationLetterGuid: '',
        maritalStatus: null,
        id: 0,
      }
      this.$refs[name].resetFields()
      if (type != '添加') {
        this.modalLoading = true
        this.getSpouseById(id)
      }
    },
    //获取配偶详情
    getSpouseById(id) {
      let index = this.spouseList.findIndex((item) => item.id === id)
      this.formSpouse = JSON.parse(JSON.stringify(this.spouseList[index]))
      this.modalLoading = false
    },
    //  删除配偶信息
    async delSpouse(id) {
      let _this = this
      this.$Modal.confirm({
        title: '提示',
        content: `<p>确认要删除此信息吗？删除后所有选择此配偶的数据需重新选择！</p>`,
        onOk: async () => {
          let { data } = await this.$Ajax.post(
            `/api/services/app/JZZJFApi/DeleteAppSpouseInfo_Children?guid=${this.form.guid}&id=${id}`
          )
          if (!data.success) {
            this.$Message.error({
              content: '删除失败,' + data.error.message,
              background: true,
              duration: 10,
              closable: true,
            })
          } else {
            await _this.$emit('delSpouseChange', id)
            this.$Message.success({
              content: '删除成功',
              background: true,
              duration: 10,
              closable: true,
            })
            this.modalShow = false
            this.getSpouseList()
          }
        },
      })
    },
    //配偶新增
    addSpouseSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }

        this.modalLoading = true
        this.formSpouse.guid = this.form.guid
        try {
          let data = await this.$Ajax.post(
            '/api/services/app/JZZJFApi/SaveAppSpouseInfo_Children',
            this.formSpouse
          )
          this.$Message.success({
            content: '添加成功',
            background: true,
            duration: 6,
          })
          this.modalShow = false
          this.getSpouseList()
        } catch (error) {
          this.modalLoading = false
        }
      })
    },
    //配偶上传材料
    handleSuccessSpouse(response, file, fileList, property, isArray) {
      // 判断目标是否为数组，并给其赋值或者插入新数据
      if (isArray) {
        // 是数组
        // if (this.form[property] == undefined) {
        if (!Array.isArray(this.formSpouse[property])) {
          //不存在先创建
          this.$set(this.formSpouse, property, [])
        }
        this.formSpouse[property].push(response.result.guid)
      } else {
        // 否则直接赋值
        this.$set(this.formSpouse, property, response.result.guid)
      }
    },
    //配偶移除材料
    handleRemoveSpouse(file, fileList, property, isArray) {
      let guid = 0
      try {
        if (file.response.result) {
          guid = file.response.result.guid
        }
      } catch (error) {
        guid = 0
      }
      if (isArray) {
        // 是数组
        let arrIndex = this.formSpouse[property].indexOf(guid)
        if (arrIndex !== -1) {
          this.formSpouse[property].splice(arrIndex, 1)
        }
      } else {
        // 否则直接赋值
        this.$set(this.formSpouse, property, null)
      }
    },
    addChild(property) {
      this.$emit('addChild', property)
    },
    delChild(property, index) {
      this.$emit('delChild', property, index)
    },
    // submit(name) {
    //   let _this = this
    //   this.$refs[name].validate((valid) => {
    //     if (!valid) {
    //       this.$Message.error('请将信息填写完整')
    //       return
    //     }
    //     this.$Modal.confirm({
    //       title: '请确认',
    //       content: `<p>是否提交信息</p>`,
    //       okText: '是',
    //       cancelText: '否',
    //       onOk: () => {
    //         _this.$emit('submit')
    //       },
    //     })
    //   })
    // },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
      try {
        this.$refs['form' + this.current].validateField(property)
      } catch (error) {}
      this.$forceUpdate()
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //通过申请人身份证判断子女需要填写的是父亲信息还是母亲信息
    idcardGetSexInInfo(idCard) {
      if (idCard.length !== 18) {
        // 身份证号码长度应为18位
        return '生父/生母'
      }
      var genderCode = idCard.substr(16, 1) // 获取第17位数字
      if (genderCode % 2 === 0) {
        //女
        return '生父'
      } else {
        // 男
        return '生母'
      }
    },
  },
}
</script>